<script setup lang="ts">
defineProps<{ active?: boolean }>()
</script>

<!--
  Onglet « Compétition ». Trait au repos, plein une fois actif — cf. l'en-tête
  de `IconHome` pour la règle.

  La géométrie ne change pas d'un état à l'autre : seules les deux formes
  FERMÉES (la coupe, le socle) se remplissent. Les anses et le pied restent du
  trait dans les deux cas, un chemin ouvert rempli donnant n'importe quoi.
-->
<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="active ? 1.6 : 1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- la coupe -->
    <path :fill="active ? 'currentColor' : 'none'" d="M7 4.2h10v5.3a5 5 0 0 1-10 0z" />
    <!-- les anses -->
    <path d="M7 6H4.6a.6.6 0 0 0-.6.6v.6a3.4 3.4 0 0 0 3.4 3.4" />
    <path d="M17 6h2.4a.6.6 0 0 1 .6.6v.6a3.4 3.4 0 0 1-3.4 3.4" />
    <!-- le pied -->
    <path d="M12 14.5v3" />
    <path d="M8.6 20.5h6.8" />
    <path :fill="active ? 'currentColor' : 'none'" d="M9.6 17.5h4.8l.6 3H9z" />
  </svg>
</template>
